import { render, staticRenderFns } from "./Items.edit.vue?vue&type=template&id=5bea01fc&"
import script from "./Items.edit.vue?vue&type=script&lang=js&"
export * from "./Items.edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports